<template>
    <div
        uk-sticky="cls-active: navbar-sticky; offset: -200"
        class="bg-white z-10 shadow navigation"
    >
        <!--div v-if="doc.nav_headline">
            <div class="font-handwritten text-gray-700 tracking-wider ms-3 lg:ms-5 font-thin text-center px-5 pt-4">{{ doc.nav_headline }}</div>
        </div-->
        <nav
            class="navbar-container z-10"
            :class="containerClass"
            uk-navbar
        >
            <div class="uk-navbar-left relative">
                <a href="/">
                    <div class="ml-12">
                        <asset
                            :url="doc.nav_logo"
                            :h="logoHeight"
                            w="auto"
                        />
                    </div>
                </a>
            </div>
            <div class="uk-navbar-center uk-visible@xl">
                <ul class="navbar uk-navbar-nav nav-bg">
                    <template
                        v-for="(page, index) in pages"
                        class="strong"
                    >
                        <li
                            :key="index"
                            v-if="!page.hide_in_navigation"
                        >
                            <router-link
                                class="link-heading"
                                :to="page.url"
                            >
                                <span class="ms-0 font-normal tracking-widest">
                                    {{ page.title }}
                                </span>
                            </router-link>

                            <div
                                v-if="page.children.length"
                                class="uk-navbar-dropdown shadow uppercase"
                                style="background-color: white"
                            >
                                <ul class="uk-nav uk-navbar-dropdown-nav">
                                    <li
                                        v-for="(child, index) in page.children"
                                        :key="index"
                                        class="py-1"
                                    >
                                        <router-link
                                            :to="child.url"
                                            class="font-normal tracking-widest"
                                        >
                                            {{ child.title }}
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </template>
                </ul>
            </div>
            <div
                v-if="doc.nav_icons"
                class="uk-navbar-right uk-visible@xl"
            >
                <div class="flex flex-wrap -ml-2 mr-3">
                    <template v-for="(item, index) in doc.nav_icons">
                        <div
                            :key="index"
                            class="px-2"
                        >
                            <anchor :field="item.link">
                                <i
                                    class="ms-5/2 text-gray-800 hover:text-primary"
                                    :class="item.icon"
                                ></i>
                            </anchor>
                        </div>
                    </template>
                </div>
            </div>
            <div class="uk-navbar-right uk-hidden@xl">
                <a
                    class="las la-bars p-2 ms-3 mr-3 text-black cursor-pointer"
                    uk-toggle="target: #mobile-nav"
                ></a>
            </div>
        </nav>

        <div
            id="mobile-nav"
            uk-offcanvas="overlay: true"
        >
            <div
                class="uk-offcanvas-bar flex flex-column"
                style="width: 320px"
            >

                <button
                    class="uk-offcanvas-close"
                    type="button"
                    uk-close
                ></button>

                <ul class="uk-nav uk-nav-primary mx-auto inverse">
                    <template
                        v-for="(page, index) in pages"
                        class="strong"
                    >
                        <li
                            :key="index"
                            v-if="!page.hide_in_navigation"
                        >
                            <router-link
                                class="link-heading"
                                :to="page.url"
                            >
                                <div class="ms-3/2 py-3 font-normal tracking-widest uppercase text-gray-400 hover:text-white">
                                    {{ page.title }}
                                </div>
                            </router-link>

                            <div v-if="page.children.length">
                                <ul class="uk-nav mb-4">
                                    <li
                                        v-for="(child, index) in page.children"
                                        :key="index"
                                        class="py-1"
                                    >
                                        <router-link
                                            :to="child.url"
                                            class="font-normal tracking-widest ms--1 uppercase block py-1"
                                        >
                                            {{ child.title }}
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "navigation",

    props: ["doc"],

    data() {
        return {
            pages: null
        };
    },

    computed: {
        containerClass() {
            var color = this.doc.nav_background_color;

            if (color === "transparent") {
                return "absolute bg-transparent w-full border-b z-10";
            }

            return (
                "relative " +
                {
                    primary: "bg-primary inverse",
                    secondary: "bg-secondary inverse",
                    muted: "bg-gray-200"
                }[color]
            );
        },
        logoHeight() {
            return this.doc.nav_logo_height || 200;
        },
        logoOffest() {
            return this.doc.nav_logo_offest || 0;
        }
    },

    created() {
        this.$structure(
            { handle: "collection::pages", includeHome: "true" },
            response => {
                this.pages = response;

                for (var i = 0; i < this.pages.length; i++) {
                    var page = this.pages[i];
                    page.children = page.children.filter(child => {
                        return !child.hide_in_navigation;
                    });
                }

                console.log("navigation");
                console.log(this);
            }
        );
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue